export default "45889ef71dfc2f26.gif"